'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = format;
exports.isNearZero = isNearZero;

var _numeral = require('@omniex/numeral');

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function format(n, format) {
  return (0, _numeral2.default)(n).format(format);
}

function isNearZero(n, threshold) {
  return Math.abs(n) < threshold;
}

exports.default = {
  format: format,
  isNearZero: isNearZero
};